<template>
  <div class="homepage-quicklink-tiles homepage-quicklink-tiles--images" :data-brand="brand.substr(0,1).toLowerCase() + brand.substr(1)">
    <div class="container">
      <div class="row text-center">
        <div class="col-xs-6 col-md-3 quicklink-tile quicklink-tile--new">
          <a href="#">
            <div v-if="brand === 'mazda' || brand === 'mitsubishi' || brand === 'nissan'" class="quicklink-tile__img" alt="New Vehicles tile image" :style="{backgroundImage: altBox}"></div>
            <div v-else class="quicklink-tile__img" alt="New Vehicles tile image" :style="{backgroundImage: newBox}"></div>
            <h4 class="quicklink-tile__title">New Vehicles</h4>
          </a>
          <a class="mazda-button quicklink-tile__btn" href="#">Shop New</a>
        </div>
        <div class="col-xs-6 col-md-3 quicklink-tile quicklink-tile--preowned">
          <a href="#">
            <div v-if="brand === 'ford'" class="quicklink-tile__img" alt="New Vehicles tile image" :style="{backgroundImage: altBox}"></div>
            <div v-else class="quicklink-tile__img" alt="Pre-Owned Vehicles tile image" :style="{backgroundImage: usedBox}"></div>
            <h4 class="quicklink-tile__title">Pre-Owned Vehicles</h4>
          </a>
          <a class="mazda-button quicklink-tile__btn" href="#">Shop Pre-Owned</a>
        </div>
        <div class="col-xs-6 col-md-3 quicklink-tile quicklink-tile--finance">
          <a href="#">
            <div class="quicklink-tile__img" alt="Financing tile image"></div>
            <h4 class="quicklink-tile__title">Financing</h4>
          </a>
          <a class="mazda-button quicklink-tile__btn" href="#">Get Pre-Approved</a>
        </div>
        <div class="col-xs-6 col-md-3 quicklink-tile quicklink-tile--service">
          <a href="#">
            <div class="quicklink-tile__img" alt="Service tile image"></div>
            <h4 class="quicklink-tile__title">Service</h4>
          </a>
          <a class="mazda-button quicklink-tile__btn" href="#">Schedule Service</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: ['images'],
    data() {
      return {
        brand: this.$store.state.chosenBrand,
        newBox: 'url(' + this.images.lifestyleImages.sedanImage + ')',
        usedBox: 'url(' + this.images.lifestyleImages.suvImage + ')',
        altBox: 'url(' + this.images.lifestyleImages.truckImage + ')',
      }
    },
    computed: {
      brandName () {
        if (this.brand === 'none') {
          return 'Brand';
        } else if (this.brand === 'infiniti' || this.brand === 'cjdr') {
          return this.brand.toUpperCase();
        } else {
          return this.brand.charAt(0).toUpperCase() + this.brand.slice(1);
        }
      }
    }
  };
</script>

<style
  scoped
  src="../../static/bootstrap-3.3.7-dist/css/bootstrap.min.css"
></style>

<style scoped>
  .homepage-quicklink-tiles {
    padding: 50px 0;
    margin: 50px 0;
  }
  .homepage-quicklink-tiles .quicklink-tile {
    padding: 15px 2px;
  }
  .homepage-quicklink-tiles .quicklink-tile__img {
    height: 300px;
    width: 100%;
    -webkit-transition: all 0.3s ease;
    -moz-transition: all 0.3s ease;
    -o-transition: all 0.3s ease;
    transition: all 0.3s ease;
    background-size: cover;
    background-position: center;
  }
  .homepage-quicklink-tiles[data-brand="mazda"] .quicklink-tile__img {
    background-position-X: 75%;
  }
  .homepage-quicklink-tiles .quicklink-tile--finance .quicklink-tile__img {
    background-image: url(../../static/images/financing-stock-img.jpeg);
  }
  .homepage-quicklink-tiles .quicklink-tile--service .quicklink-tile__img {
    background-image: url(../../static/images/parts-service-stock-image.jpeg);
  }
  .homepage-quicklink-tiles .quicklink-tile__img:hover {
    opacity: 0.4;
  }
  .homepage-quicklink-tiles .quicklink-tile__title {
    color: var(--primary-dark);
    margin: 15px 0;
    min-height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .homepage-quicklink-tiles .quicklink-tile a:hover, 
  .homepage-quicklink-tiles .quicklink-tile a:active, 
  .homepage-quicklink-tiles .quicklink-tile a:focus {
    text-decoration: none;
  }
  .homepage-quicklink-tiles .quicklink-tile__btn {
    min-width: 175px;
  }
  .homepage-quicklink-tiles .mazda-button {
    display: inline-block;
    background-color: var(--primary-color);
    border: solid 2px var(--primary-color);
    color: #ffffff;
    border-radius: 3px;
    font-size: 13px;
    text-transform: uppercase;
    padding: 14px 11px;
    margin: 5px 0px;
    -webkit-transition: all 0.3s ease;
    -moz-transition: all 0.3s ease;
    -o-transition: all 0.3s ease;
    transition: all 0.3s ease;
  }
  .homepage-quicklink-tiles[data-brand="mazda"] .mazda-button {
    letter-spacing: 2px;
  }
  .homepage-quicklink-tiles .mazda-button:hover {
    opacity: .6;
  }

  @media (max-width: 767px) {
    .homepage-quicklink-tiles .quicklink-tile__title {
      min-height: 40px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
</style>
